import { render, staticRenderFns } from "./whatifCard.vue?vue&type=template&id=97592c10&"
import script from "./whatifCard.vue?vue&type=script&lang=js&"
export * from "./whatifCard.vue?vue&type=script&lang=js&"
import style0 from "./whatifCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports